import { ZapierScanActionPayload } from '@hakimo-ui/hakimo/types';
import { getEnvironmentFromHostname } from '@hakimo-ui/hakimo/util';
import { useMemo } from 'react';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';
/**
 * A data-access hook that provides a mutation function to send a SCAN action to the backend Zapier proxy.
 *
 * @param onSuccess - Optional callback for a successful mutation.
 * @param onError - Optional callback for a mutation error.
 * @returns A mutation object from `useAuthenticatedMutation`.
 */
export function useSendScanActionToZapier(
  onSuccess?: () => void,
  onError?: (err: Error) => void
) {
  const ZAPIER_PROXY_URL = '/v2/orm/unifiedalarmgroups/zapier_proxy';
  const environmentVal = getEnvironmentFromHostname();
  const requestTemplate = useMemo(
    () =>
      new Request(ZAPIER_PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      }),
    []
  );
  // Get the original mutation
  const mutation = useAuthenticatedMutation<null, ZapierScanActionPayload>(
    requestTemplate,
    {
      onSuccess,
      onError,
    }
  );
  // Wrap mutate to inject environment
  const mutateWithEnv = (payload: ZapierScanActionPayload) =>
    mutation.mutate({ ...payload, environment: environmentVal });
  return { ...mutation, mutate: mutateWithEnv };
}

export default useSendScanActionToZapier;
